import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";

// Карточка outbox-admin-visibility (волна 4). Список застрявших/мёртвых строк
// integration_outbox + ретрай (одна строка / все dead). Все эндпоинты за
// integrations:manage (management) на бэке.

export interface OutboxRow {
  id: string;
  target: string;
  kind: string;
  aggregateId: string;
  status: string;
  attempts: number;
  lastError: string | null;
  createdAt: string;
  nextRetryAt: string;
  requestNumber: string | null;
}

const OUTBOX_QUERY_KEY = "integrations-outbox";

export function useOutboxRows(enabled = true) {
  return useQuery({
    queryKey: [OUTBOX_QUERY_KEY],
    queryFn: () => api<OutboxRow[]>("/admin/integrations/outbox"),
    enabled,
  });
}

export function useRetryOutboxRow() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      api<{ ok: true; id: string }>(`/admin/integrations/outbox/${id}/retry`, {
        method: "POST",
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [OUTBOX_QUERY_KEY] });
      qc.invalidateQueries({ queryKey: ["ops-hub-stats"] });
    },
  });
}

export function useRetryDeadOutbox() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      api<{ ok: true; retried: number }>("/admin/integrations/outbox/retry-dead", {
        method: "POST",
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [OUTBOX_QUERY_KEY] });
      qc.invalidateQueries({ queryKey: ["ops-hub-stats"] });
    },
  });
}
